import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { CompanyDirectoryCore } from '@/components/companies/CompanyDirectoryCore';
import { Building2, ArrowRight } from 'lucide-react';

export default function CompaniesDirectory() {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="container py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">{t('companies.title')}</h1>
          <p className="mt-2 text-muted-foreground">{t('companies.description')}</p>
        </div>

        {/* Cross-link to supplier hub */}
        <Link
          to="/suppliers"
          className="mb-8 flex items-center justify-between rounded-lg border border-secondary/30 bg-secondary/5 px-5 py-3 transition-all hover:border-secondary/60 hover:bg-secondary/10"
        >
          <div className="flex items-center gap-3">
            <Building2 className="h-4 w-4 text-secondary" />
            <span className="text-sm font-medium">{t('companies.supplierCrossLink')}</span>
          </div>
          <ArrowRight className="h-4 w-4 text-secondary" />
        </Link>

        <CompanyDirectoryCore
          lockedTypeFilters={['us_company', 'multinational', 'other']}
          hideTypeFilter
        />
      </div>
    </Layout>
  );
}
